import { h } from 'preact';
import { Text } from 'preact-i18n';

// Extra lines for a public calendar row that comes from, or is merged with, the NSF
// terminliste (lib/nsf-frontpage-stevner.js in the backend): organiser for foreign
// stevner, stevnetype, NM/DM/KM badge and a cancelled marker. Plain calendar events
// and courses render nothing.
export function PublicEventExtras({ event = {} }) {
    if (!event.isNsfCompetition && !event.competitionTypeName && !event.championship && !event.cancelled) {
        return null;
    }
    return (
        <span class='small ms-2'>
            {event.isNsfCompetition && event.organizationName && (
                <span class='text-body-secondary me-2'>
                    <i class='fa-solid fa-people-group me-1' />
                    {event.organizationName}
                </span>
            )}
            {event.competitionTypeName && (
                <span class='text-body-secondary me-1'>{event.competitionTypeName}</span>
            )}
            {event.championship && (
                <span class='badge text-bg-warning align-middle me-1'>
                    <i class='fa-duotone fa-trophy me-1' />
                    {event.championship}
                </span>
            )}
            {event.cancelled && (
                <span class='badge text-bg-danger align-middle'>
                    <Text id='terminliste.cancelled'>Cancelled</Text>
                </span>
            )}
        </span>
    );
}

export default PublicEventExtras;
